import VInputMoney from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputMoney', VInputMoney),
};
